export default __webpack_public_path__ + "static/media/trr-event-yoga.ac73f080.png";